<template>
<!-- pc端 -->
<div class="mains-page" v-if="isSmallScreen===false">
  <div class="industry">
    <!-- | Series Products -->
  <p class="indestry-lif">{{res1}} | Series Products</p>
  <p class="indestry-w">Why choose us</p>
</div>
<div class="indus">
  <p class="indus-chan" v-if="res1 !=='碳立方的优势'">产品简介  <span> Product introduction</span></p>
  <p class="i-p">{{res2}}</p>
  <p class="i-p">{{res3}}</p>
  <p class="indus-chan1" v-if="res1 !=='碳立方的优势'">案例简介  <span> Case introduction</span></p>
  <p class="i-p">{{res4}}</p>
</div>
<img class="kongpai" :src="require('@/assets/2023logoImage/' +formattedSrc)">
</div>
<!-- 移动端 -->
<div class="mains-page" v-else>
  <div class="industry">
  <p class="indestry-lif">{{res1}}</p>
  <p class="indestry-w">Why choose us</p>
</div>
<div class="indus">
  <!-- <p class="indus-chan" v-if="res1 !=='碳立方的优势'">产品简介  <span> Product introduction</span></p>
  <p class="i-p">{{res2}}{{res3}}</p> -->
  <p class="indus-chan1" v-if="res1 !=='碳立方的优势'">案例简介  <span> Case introduction</span></p>
  <p class="i-p">{{res4}}</p>
</div>
<!-- <img class="kongpai" :src="require('../assets/2023logoImage/' +formattedSrc)"> -->
  <p class="zhuyao">主要路径</p>
  <div class="hengpai1">
   <div class="left-heng1">
       <p class="heng-blue1"><span class="num1">01</span><span class="yuan1"></span>现状摸排</p>
       <p class="moqing1">摸清碳排家底+减碳有的放矢</p>
   </div>
    <img class="parks1" src="../assets/park/xzmp.png" alt="">
  </div>
  <div class="hengpai2">
   <div class="left-heng2">
       <p class="heng-blue2"><span class="num2">02</span><span class="yuan2"></span> 方案规划</p>
       <p class="moqing2">科学评估潜力+节能减排最优解</p>
   </div>
    <img class="parks2" src="../assets/park/fagh.png" alt="">
  </div>
  <div class="hengpai3">
      <div class="left-heng3">
        <p class="heng-blue3"><span class="num3">03</span><span class="yuan3"></span> 数字化建设</p>
        <p class="moqing3">共建零碳园区</p>
      </div>
    <img class="parks3" src="../assets/park/szhjs.png" alt="">
  </div>
  <div class="hengpai4">
      <div class="left-heng4">
        <p class="heng-blue4"><span class="num4">04</span><span class="yuan4"></span>  交付运营</p>
        <p class="moqing4">靠谱交付+精细运维+无忧服务</p>
      </div>
    <img class="parks4" src="../assets/park/jcyy.png" alt="">
  </div>
  <div>
    <p class="zhuyao">关键举措</p>
    <img class="guanjian" src="../assets/park/gjjc.png" alt="">
  </div>
</div>
</template>
<script>
export default {
  props: {
    res1: {
      type: String,
      default: ''
    },
    res2: {
      type: String,
      default: ''
    },
    res3: {
      type: String,
      default: ''
    },
    res4: {
      type: String,
      default: ''
    },
    res5: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      formattedSrc: '',
      isSmallScreen: false
    }
  },
  created () {
    this.formattedSrc = this.res5.slice(24)
  },
  mounted () {
    this.formattedSrc = this.res5.slice(24)
    if (document.querySelector('body').offsetWidth < 1000) {
      this.isSmallScreen = true
    } else {
      this.isSmallScreen = false
      // var res = document.querySelector('.header-navbar')
      // if (res) {
      //   res.style.opacity = '0.5'
      // }
    }
  }
}
</script>
<style scoped lang="scss">
    .industry{
    text-align: center;
    margin-top:100px ;
    width: 100%;
    border-bottom: 1px solid #ececec ;
    .indestry-lif{
      font-size: 27px;
      font-weight: 500;
      margin-bottom: 10px ;
    }
    .indestry-w{
      color: #9a9a9a;
      margin-bottom: 20px;
    }
  }
  .indus{
    margin-top: 100px;
    margin-left: 15%;
    .indus-chan{
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .indus-chan1{
      margin-top: 73px;
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .i-p{
      font-size: 14px;
      color: #9a9a9a;
      margin-bottom: 14px;
    }
  }
  .kongpai{
    margin: 53px auto;
    width: 1155px;
    // height: 728px;
  }
@media screen and (min-width: 1920px) {
    .industry{
    text-align: center;
    margin-top:100px ;
    width: 100%;
    border-bottom: 1px solid #ececec ;
    .indestry-lif{
      font-size: 27px;
      font-weight: 500;
      margin-bottom: 10px ;
    }
    .indestry-w{
      color: #9a9a9a;
      margin-bottom: 20px;
    }
  }
  .indus{
    margin-top: 100px;
    margin-left: 375px;
    .indus-chan{
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .indus-chan1{
      margin-top: 73px;
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .i-p{
      font-size: 14px;
      color: #9a9a9a;
      margin-bottom: 14px;
    }
  }
  .kongpai{
    margin: 53px auto;
    width: 1155px;
    // height: 728px;
  }
}
@media screen and (max-width:1000px) and (min-width:768px) {
    .industry{
    text-align: center;
    margin-top:10px ;
    width: 100%;
    border-bottom: 1px solid #ececec ;
    .indestry-lif{
      font-size: 17px;
      font-weight: 500;
      margin-bottom: 10px ;
    }
    .indestry-w{
      color: #9a9a9a;
      margin-bottom: 10px;
    }
  }
  .indus{
    margin-top: 10px;
    margin-left: 15px;
    .indus-chan{
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 20px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .indus-chan1{
      margin-top: 30px;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .i-p{
      font-size: 14px;
      color: #9a9a9a;
      margin-bottom: 14px;
    }
  }
  .kongpai{
    margin: 23px,20px, 23px, 20px;
    width: 90%;
    // height: 250px;
    // height: 880px;
    height: 100%;
  }
  .zhuyao{
    text-align: center;
    color: #6accce;
    font-weight: 700;
    margin-top: 73px;
    margin-bottom: 20px;
  }
  .hengpai1{
    margin-top:10px ;
    margin-left:-35px ;
    display: flex;
    justify-content: center;
    align-items: center;
    .left-heng1{
      .heng-blue1{
        margin-left:-20px ;
        margin-bottom: 10px ;
        color: #5086c2;
        font-weight: 700;
        .num1{
          margin-right: 10px;
        }
        // .yuan1{
        //   position: absolute;
        //   top: 976px;
        //   left: 211px;
        //   display: inline-block;
        //   width: 18px;
        //   height: 18px;
        //   border-radius: 50%;
        //   border: 1px solid #5086c2;
        // }
      }
        .moqing1{
          margin-left:5px ;
          color: #6f6b6b;
          font-size: 12px;
        }
    }
    .parks1{
      width: 130px;
      height: 100px;
      position: relative;
      top: 0;
      left: 35px;
    }
  }
  .hengpai2{
    margin-top:10px ;
    margin-left:-48px ;
    display: flex;
    justify-content: center;
    align-items: center;
    .left-heng2{
      .heng-blue2{
        margin-left:2px ;
        margin-bottom: 10px ;
        color: #5086c2;
        font-weight: 700;
        .num2{
          margin-right: 5px;
          // margin-left:10px ;
        }
        // .yuan2{
        //   position: absolute;
        //   top: 1086px;
        //   left: 210px;
        //   display: inline-block;
        //   width: 18px;
        //   height: 18px;
        //   border-radius: 50%;
        //   border: 1px solid #5086c2;
        // }
      }
        .moqing2{
          margin-left:27px ;
          color: #6f6b6b;
          font-size: 12px;
        }
    }
    .parks2{
      width: 130px;
      height: 100px;
      position: relative;
      top: 0;
      left: 35px;
    }
  }
  .hengpai3{
    margin-top:10px ;
    margin-left:-208px ;
    display: flex;
    justify-content: center;
    align-items: center;
    .left-heng3{
      .heng-blue3{
        margin-left:82px ;
        margin-bottom: 10px ;
        color: #5086c2;
        font-weight: 700;
        .num3{
          margin-right: 5px;
          // margin-left:10px ;
        }
        // .yuan3{
        //   position: absolute;
        //   top:1196px;
        //   left: 209px;
        //   display: inline-block;
        //   width: 18px;
        //   height: 18px;
        //   border-radius: 50%;
        //   border: 1px solid #5086c2;
        // }
      }
        .moqing3{
          margin-left:111px ;
          color: #6f6b6b;
          font-size: 12px;
        }
    }
    .parks3{
      width: 130px;
      height: 100px;
      position: relative;
      top: 0;
      left: 116px;
    }
  }
  .hengpai4{
    margin-top:10px ;
    margin-left:-208px ;
    display: flex;
    justify-content: center;
    align-items: center;
    .left-heng4{
      .heng-blue4{
        margin-left:157px ;
        margin-bottom: 10px ;
        color: #5086c2;
        font-weight: 700;
        .num4{
          margin-right: 5px;
          // margin-left:10px ;
        }
        // .yuan4{
        //   position: absolute;
        //   top: 1307px;
        //   left: 210px;
        //   display: inline-block;
        //   width: 18px;
        //   height: 18px;
        //   border-radius: 50%;
        //   border: 1px solid #5086c2;
        // }
      }
        .moqing4{
          margin-left:182px ;
          color: #6f6b6b;
          font-size: 12px;
        }
    }
    .parks4{
      width: 130px;
      height: 100px;
      position: relative;
      top: 0;
      left: 39px;
    }
  }
  .guanjian{
    width: 90%;
    padding-top: 20px;
    margin: 0 auto;
  }
}
@media screen and (max-width:375px) {
    .industry{
    text-align: center;
    margin-top:73px ;
    width: 100%;
    border-bottom: 1px solid #ececec ;
    .indestry-lif{
      font-size: 20px;
      font-weight: 700;
      margin-bottom: 10px ;
    }
    .indestry-w{
      margin-top:24px ;
      color: #9a9a9a;
      margin-bottom: 10px;
    }
  }
  .indus{
    margin-top: 10px;
    margin-left: 25px;
    margin-right: 25px;
    .indus-chan{
      margin-top:45px ;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 20px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .indus-chan1{
      margin-top: 30px;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .i-p{
      font-size: 14px;
      color: #9a9a9a;
      margin-bottom: 14px;
    }
  }
  .kongpai{
    margin: 23px,20px, 23px, 20px;
    width: 90%;
    // height: 250px;
    height: 100%;
  }
  .zhuyao{
    text-align: center;
    color: #6accce;
    font-weight: 700;
    margin-top: 10px;
    margin-bottom: 20px;
  }
  .hengpai1{
    margin-top:10px ;
    margin-left:-35px ;
    display: flex;
    justify-content: center;
    align-items: center;
    .left-heng1{
      .heng-blue1{
        margin-left:14px ;
        margin-bottom: 10px ;
        color: #5086c2;
        font-weight: 700;
        .num1{
          margin-right: 10px;
        }
        // .yuan1{
        //   position: absolute;
        //   top: 866px;
        //   left: 13px;
        //   display: inline-block;
        //   width: 18px;
        //   height: 18px;
        //   border-radius: 50%;
        //   border: 1px solid #5086c2;
        // }
      }
        .moqing1{
          margin-left:42px ;
          color: #6f6b6b;
          font-size: 12px;
        }
    }
    .parks1{
      width: 130px;
      height: 100px;
      position: relative;
      top: 0;
      left: 30px;
    }
  }
  .hengpai2{
    margin-top:10px ;
    margin-left:-48px ;
    display: flex;
    justify-content: center;
    align-items: center;
    .left-heng2{
      .heng-blue2{
        margin-left:39px ;
        margin-bottom: 10px ;
        color: #5086c2;
        font-weight: 700;
        .num2{
          margin-right: 5px;
          // margin-left:10px ;
        }
        // .yuan2{
        //   position: absolute;
        //   top: 976px;
        //   left: 13px;
        //   display: inline-block;
        //   width: 18px;
        //   height: 18px;
        //   border-radius: 50%;
        //   border: 1px solid #5086c2;
        // }
      }
        .moqing2{
          margin-left:68px ;
          color: #6f6b6b;
          font-size: 12px;
        }
    }
    .parks2{
      width: 130px;
      height: 100px;
      position: relative;
      top: 0;
      left: 18px;
    }
  }
  .hengpai3{
    margin-top:10px ;
    margin-left:-208px ;
    display: flex;
    justify-content: center;
    align-items: center;
    .left-heng3{
      .heng-blue3{
        margin-left:115px ;
        margin-bottom: 10px ;
        color: #5086c2;
        font-weight: 700;
        .num3{
          margin-right: 5px;
          // margin-left:10px ;
        }
        // .yuan3{
        //   position: absolute;
        //   top: 1087px;
        //   left: 13px;
        //   display: inline-block;
        //   width: 18px;
        //   height: 18px;
        //   border-radius: 50%;
        //   border: 1px solid #5086c2;
        // }
      }
        .moqing3{
          margin-left:142px ;
          color: #6f6b6b;
          font-size: 12px;
        }
    }
    .parks3{
      width: 130px;
      height: 100px;
      position: relative;
      top: 0;
      left: 100px;
    }
  }
  .hengpai4{
    margin-top:10px ;
    margin-left:-208px ;
    display: flex;
    justify-content: center;
    align-items: center;
    .left-heng4{
      .heng-blue4{
        margin-left:193px ;
        margin-bottom: 10px ;
        color: #5086c2;
        font-weight: 700;
        .num4{
          margin-right: 5px;
          // margin-left:10px ;
        }
        // .yuan4{
        //   position: absolute;
        //   top: 1197px;
        //   left: 13px;
        //   display: inline-block;
        //   width: 18px;
        //   height: 18px;
        //   border-radius: 50%;
        //   border: 1px solid #5086c2;
        // }
      }
        .moqing4{
          margin-left:220px ;
          color: #6f6b6b;
          font-size: 12px;
        }
    }
    .parks4{
      width: 130px;
      height: 100px;
      position: relative;
      top: 0;
      left: 27px;
    }
  }
  .guanjian{
    width: 90%;
    padding-top: 20px;
    margin: 0 auto;
  }
}
@media screen and (max-width:414px) and (min-width: 391px) {
        .industry{
    text-align: center;
    margin-top:50px ;
    width: 100%;
    border-bottom: 1px solid #ececec ;
    .indestry-lif{
      font-size: 20px;
      font-weight: 700;
      margin-bottom: 10px ;
    }
    .indestry-w{
      margin-top:12px ;
      color: #9a9a9a;
      margin-bottom: 16px;
    }
  }
  .indus{
    margin-top: 10px;
    margin-left: 25px;
    margin-right: 25px ;
    margin-bottom:50px ;
    .indus-chan{
      margin-top:44px ;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 28px;
      span{
        font-weight: 400;
        margin-left: 12px;
      }
    }
    .indus-chan1{
      margin-top: 40px;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 28px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .i-p{
      font-size: 14px;
      color: #9a9a9a;
      margin-bottom: 14px;
    }
  }
  .kongpai{
    margin: 23px,20px, 23px, 20px;
    width: 90%;
    // height: 319px;
    height: 100%;
  }
  .zhuyao{
    text-align: center;
    color: #6accce;
    font-weight: 700;
    margin-top: 10px;
    margin-bottom: 20px;
  }
  .hengpai1{
    margin-top:10px ;
    margin-left:-35px ;
    display: flex;
    justify-content: center;
    align-items: center;
    .left-heng1{
      .heng-blue1{
        margin-left:-20px ;
        margin-bottom: 10px ;
        color: #5086c2;
        font-weight: 700;
        .num1{
          margin-right: 10px;
        }
        // .yuan1{
        //   position: absolute;
        //   // top: 893px;
        //   top: 913px;
        //   left: 34px;
        //   display: inline-block;
        //   width: 18px;
        //   height: 18px;
        //   border-radius: 50%;
        //   border: 1px solid #5086c2;
        // }
      }
        .moqing1{
          margin-left:8px ;
          color: #6f6b6b;
          font-size: 12px;
        }
    }
    .parks1{
      width: 130px;
      height: 100px;
      position: relative;
      top: 0;
      left: 35px;
    }
  }
  .hengpai2{
    margin-top:10px ;
    margin-left:-48px ;
    display: flex;
    justify-content: center;
    align-items: center;
    .left-heng2{
      .heng-blue2{
        margin-left:2px ;
        margin-bottom: 10px ;
        color: #5086c2;
        font-weight: 700;
        .num2{
          margin-right: 5px;
          // margin-left:10px ;
        }
        // .yuan2{
        //   position: absolute;
        //   // top: 1004px;
        //   top: 1024px;
        //   left: 33px;
        //   display: inline-block;
        //   width: 18px;
        //   height: 18px;
        //   border-radius: 50%;
        //   border: 1px solid #5086c2;
        // }
      }
        .moqing2{
          margin-left:30px ;
          color: #6f6b6b;
          font-size: 12px;
        }
    }
    .parks2{
      width: 130px;
      height: 100px;
      position: relative;
      top: 0;
      left: 35px;
    }
  }
  .hengpai3{
    margin-top:10px ;
    margin-left:-208px ;
    display: flex;
    justify-content: center;
    align-items: center;
    .left-heng3{
      .heng-blue3{
        margin-left:80px ;
        margin-bottom: 10px ;
        color: #5086c2;
        font-weight: 700;
        .num3{
          margin-right: 5px;
          // margin-left:10px ;
        }
        // .yuan3{
        //   position: absolute;
        //   // top: 1114px;
        //   top: 1134px;
        //   left: 32px;
        //   display: inline-block;
        //   width: 18px;
        //   height: 18px;
        //   border-radius: 50%;
        //   border: 1px solid #5086c2;
        // }
      }
        .moqing3{
          margin-left:109px ;
          color: #6f6b6b;
          font-size: 12px;
        }
    }
    .parks3{
      width: 130px;
      height: 100px;
      position: relative;
      top: 0;
      left: 116px;
    }
  }
  .hengpai4{
    margin-top:10px ;
    margin-left:-208px ;
    display: flex;
    justify-content: center;
    align-items: center;
    .left-heng4{
      .heng-blue4{
        margin-left:157px ;
        margin-bottom: 10px ;
        color: #5086c2;
        font-weight: 700;
        .num4{
          margin-right: 5px;
          // margin-left:10px ;
        }
        // .yuan4{
        //   position: absolute;
        //   // top: 1223px;
        //   top: 1243px;
        //   left: 33px;
        //   display: inline-block;
        //   width: 18px;
        //   height: 18px;
        //   border-radius: 50%;
        //   border: 1px solid #5086c2;
        // }
      }
        .moqing4{
          margin-left:184px ;
          color: #6f6b6b;
          font-size: 12px;
        }
    }
    .parks4{
      width: 130px;
      height: 100px;
      position: relative;
      top: 0;
      left: 39px;
    }
  }
  .guanjian{
    width: 90%;
    padding-top: 20px;
    margin: 0 auto;
  }
}
@media screen and (max-width:767px) and (min-width: 415px) {
     .industry{
    text-align: center;
    margin-top:73px ;
    width: 100%;
    border-bottom: 1px solid #ececec ;
    .indestry-lif{
      font-size: 20px;
      font-weight: 700;
      margin-bottom: 10px ;
    }
    .indestry-w{
      margin-top:24px ;
      color: #9a9a9a;
      margin-bottom: 10px;
    }
  }
  .indus{
    margin-top: 10px;
    margin-left: 25px;
    margin-right: 25px;
    .indus-chan{
      margin-top:45px ;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 20px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .indus-chan1{
      margin-top: 30px;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .i-p{
      font-size: 14px;
      color: #9a9a9a;
      margin-bottom: 14px;
    }
  }
  .kongpai{
    margin: 23px,20px, 23px, 20px;
    width: 90%;
    // height: 250px;
    height: 100%;
  }
  .zhuyao{
    text-align: center;
    color: #6accce;
    font-weight: 700;
    margin-top: 10px;
    margin-bottom: 20px;
  }
  .hengpai1{
    margin-top:10px ;
    margin-left:-35px ;
    display: flex;
    justify-content: center;
    align-items: center;
    .left-heng1{
      .heng-blue1{
        margin-left:-20px ;
        margin-bottom: 10px ;
        color: #5086c2;
        font-weight: 700;
        .num1{
          margin-right: 10px;
        }
        // .yuan1{
        //   position: absolute;
        //   top: 893px;
        //   left: 34px;
        //   display: inline-block;
        //   width: 18px;
        //   height: 18px;
        //   border-radius: 50%;
        //   border: 1px solid #5086c2;
        // }
      }
        .moqing1{
          margin-left:5px ;
          color: #6f6b6b;
          font-size: 12px;
        }
    }
    .parks1{
      width: 130px;
      height: 100px;
      position: relative;
      top: 0;
      left: 35px;
    }
  }
  .hengpai2{
    margin-top:10px ;
    margin-left:-48px ;
    display: flex;
    justify-content: center;
    align-items: center;
    .left-heng2{
      .heng-blue2{
        margin-left:2px ;
        margin-bottom: 10px ;
        color: #5086c2;
        font-weight: 700;
        .num2{
          margin-right: 5px;
          // margin-left:10px ;
        }
        // .yuan2{
        //   position: absolute;
        //   top: 1004px;
        //   left: 33px;
        //   display: inline-block;
        //   width: 18px;
        //   height: 18px;
        //   border-radius: 50%;
        //   border: 1px solid #5086c2;
        // }
      }
        .moqing2{
          margin-left:27px ;
          color: #6f6b6b;
          font-size: 12px;
        }
    }
    .parks2{
      width: 130px;
      height: 100px;
      position: relative;
      top: 0;
      left: 35px;
    }
  }
  .hengpai3{
    margin-top:10px ;
    margin-left:-208px ;
    display: flex;
    justify-content: center;
    align-items: center;
    .left-heng3{
      .heng-blue3{
        margin-left:82px ;
        margin-bottom: 10px ;
        color: #5086c2;
        font-weight: 700;
        .num3{
          margin-right: 5px;
          // margin-left:10px ;
        }
        // .yuan3{
        //   position: absolute;
        //   top: 1114px;
        //   left: 32px;
        //   display: inline-block;
        //   width: 18px;
        //   height: 18px;
        //   border-radius: 50%;
        //   border: 1px solid #5086c2;
        // }
      }
        .moqing3{
          margin-left:111px ;
          color: #6f6b6b;
          font-size: 12px;
        }
    }
    .parks3{
      width: 130px;
      height: 100px;
      position: relative;
      top: 0;
      left: 116px;
    }
  }
  .hengpai4{
    margin-top:10px ;
    margin-left:-208px ;
    display: flex;
    justify-content: center;
    align-items: center;
    .left-heng4{
      .heng-blue4{
        margin-left:157px ;
        margin-bottom: 10px ;
        color: #5086c2;
        font-weight: 700;
        .num4{
          margin-right: 5px;
          // margin-left:10px ;
        }
        // .yuan4{
        //   position: absolute;
        //   top: 1223px;
        //   left: 33px;
        //   display: inline-block;
        //   width: 18px;
        //   height: 18px;
        //   border-radius: 50%;
        //   border: 1px solid #5086c2;
        // }
      }
        .moqing4{
          margin-left:182px ;
          color: #6f6b6b;
          font-size: 12px;
        }
    }
    .parks4{
      width: 130px;
      height: 100px;
      position: relative;
      top: 0;
      left: 39px;
    }
  }
  .guanjian{
    width: 90%;
    padding-top: 20px;
    margin: 0 auto;
  }
}
@media screen and (max-width:1440px) and (min-width:1000px) {
    .industry{
    text-align: center;
    margin-top:100px ;
    width: 100%;
    border-bottom: 1px solid #ececec ;
    .indestry-lif{
      font-size: 27px;
      font-weight: 500;
      margin-bottom: 10px ;
    }
    .indestry-w{
      color: #9a9a9a;
      margin-bottom: 10px;
    }
  }
  .indus{
    margin-top: 10px;
    margin-left: 15px;
    .indus-chan{
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 20px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .indus-chan1{
      margin-top: 30px;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .i-p{
      font-size: 14px;
      color: #9a9a9a;
      margin-bottom: 14px;
    }
  }
  .kongpai{
    margin: 23px,20px, 23px, 20px;
    width: 90%;
    // height: 250px;
    // height: 880px;
  }
  .zhuyao{
    text-align: center;
    color: #6accce;
    font-weight: 700;
    margin-top: 73px;
    margin-bottom: 20px;
  }
  .hengpai1{
    margin-top:10px ;
    margin-left:-35px ;
    display: flex;
    justify-content: center;
    align-items: center;
    .left-heng1{
      .heng-blue1{
        margin-left:-20px ;
        margin-bottom: 10px ;
        color: #5086c2;
        font-weight: 700;
        .num1{
          margin-right: 10px;
        }
        // .yuan1{
        //   position: absolute;
        //   top: 872px;
        //   left: 236px;
        //   display: inline-block;
        //   width: 18px;
        //   height: 18px;
        //   border-radius: 50%;
        //   border: 1px solid #5086c2;
        // }
      }
        .moqing1{
          margin-left:5px ;
          color: #6f6b6b;
          font-size: 12px;
        }
    }
    .parks1{
      width: 130px;
      height: 100px;
      position: relative;
      top: 0;
      left: 35px;
    }
  }
  .hengpai2{
    margin-top:10px ;
    margin-left:-48px ;
    display: flex;
    justify-content: center;
    align-items: center;
    .left-heng2{
      .heng-blue2{
        margin-left:2px ;
        margin-bottom: 10px ;
        color: #5086c2;
        font-weight: 700;
        .num2{
          margin-right: 5px;
          // margin-left:10px ;
        }
        // .yuan2{
        //   position: absolute;
        //   top: 982px;
        //   left: 236px;
        //   display: inline-block;
        //   width: 18px;
        //   height: 18px;
        //   border-radius: 50%;
        //   border: 1px solid #5086c2;
        // }
      }
        .moqing2{
          margin-left:27px ;
          color: #6f6b6b;
          font-size: 12px;
        }
    }
    .parks2{
      width: 130px;
      height: 100px;
      position: relative;
      top: 0;
      left: 35px;
    }
  }
  .hengpai3{
    margin-top:10px ;
    margin-left:-208px ;
    display: flex;
    justify-content: center;
    align-items: center;
    .left-heng3{
      .heng-blue3{
        margin-left:82px ;
        margin-bottom: 10px ;
        color: #5086c2;
        font-weight: 700;
        .num3{
          margin-right: 5px;
          // margin-left:10px ;
        }
        // .yuan3{
        //   position: absolute;
        //   top:1092px;
        //   left: 236px;
        //   display: inline-block;
        //   width: 18px;
        //   height: 18px;
        //   border-radius: 50%;
        //   border: 1px solid #5086c2;
        // }
      }
        .moqing3{
          margin-left:111px ;
          color: #6f6b6b;
          font-size: 12px;
        }
    }
    .parks3{
      width: 130px;
      height: 100px;
      position: relative;
      top: 0;
      left: 116px;
    }
  }
  .hengpai4{
    margin-top:10px ;
    margin-left:-208px ;
    display: flex;
    justify-content: center;
    align-items: center;
    .left-heng4{
      .heng-blue4{
        margin-left:157px ;
        margin-bottom: 10px ;
        color: #5086c2;
        font-weight: 700;
        .num4{
          margin-right: 5px;
          // margin-left:10px ;
        }
        // .yuan4{
        //   position: absolute;
        //   top: 1202px;
        //   left: 236px;
        //   display: inline-block;
        //   width: 18px;
        //   height: 18px;
        //   border-radius: 50%;
        //   border: 1px solid #5086c2;
        // }
      }
        .moqing4{
          margin-left:182px ;
          color: #6f6b6b;
          font-size: 12px;
        }
    }
    .parks4{
      width: 130px;
      height: 100px;
      position: relative;
      top: 0;
      left: 39px;
    }
  }
  .guanjian{
    width: 90%;
    padding-top: 20px;
    margin: 0 auto;
  }
}
@media screen and (max-width:390px) and (min-width: 376px) {
        .industry{
    text-align: center;
    margin-top:50px ;
    width: 100%;
    border-bottom: 1px solid #ececec ;
    .indestry-lif{
      font-size: 20px;
      font-weight: 700;
      margin-bottom: 10px ;
    }
    .indestry-w{
      margin-top:12px ;
      color: #9a9a9a;
      margin-bottom: 16px;
    }
  }
  .indus{
    margin-top: 10px;
    margin-left: 27px;
    margin-right: 25px ;
    margin-bottom:50px ;
    .indus-chan{
      margin-top:44px ;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 28px;
      span{
        font-weight: 400;
        margin-left: 12px;
      }
    }
    .indus-chan1{
      margin-top: 40px;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 28px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .i-p{
      font-size: 14px;
      color: #9a9a9a;
      margin-bottom: 14px;
    }
  }
  .kongpai{
    margin: 23px,20px, 23px, 20px;
    width: 90%;
    // height: 319px;
    height: 100%;
  }
  .zhuyao{
    text-align: center;
    color: #6accce;
    font-weight: 700;
    margin-top: 10px;
    margin-bottom: 20px;
  }
  .hengpai1{
    margin-top:10px ;
    margin-left:-11px ;
    display: flex;
    justify-content: center;
    align-items: center;
    .left-heng1{
      .heng-blue1{
        margin-left:-18px ;
        margin-bottom: 10px ;
        color: #5086c2;
        font-weight: 700;
        .num1{
          margin-right: 10px;
        }
        // .yuan1{
        //   position: absolute;
        //   // top: 893px;
        //   top: 913px;
        //   left: 34px;
        //   display: inline-block;
        //   width: 18px;
        //   height: 18px;
        //   border-radius: 50%;
        //   border: 1px solid #5086c2;
        // }
      }
        .moqing1{
          margin-left:8px ;
          color: #6f6b6b;
          font-size: 12px;
        }
    }
    .parks1{
      width: 130px;
      height: 100px;
      position: relative;
      top: 0;
      left: 33px;
    }
  }
  .hengpai2{
    margin-top:10px ;
    margin-left:-17px ;
    display: flex;
    justify-content: center;
    align-items: center;
    .left-heng2{
      .heng-blue2{
        margin-left:2px ;
        margin-bottom: 10px ;
        color: #5086c2;
        font-weight: 700;
        .num2{
          margin-right: 5px;
          // margin-left:10px ;
        }
        // .yuan2{
        //   position: absolute;
        //   // top: 1004px;
        //   top: 1024px;
        //   left: 33px;
        //   display: inline-block;
        //   width: 18px;
        //   height: 18px;
        //   border-radius: 50%;
        //   border: 1px solid #5086c2;
        // }
      }
        .moqing2{
          margin-left:29px ;
          color: #6f6b6b;
          font-size: 12px;
        }
    }
    .parks2{
      width: 130px;
      height: 100px;
      position: relative;
      top: 0;
      left: 19px;
    }
  }
  .hengpai3{
    margin-top:10px ;
    margin-left:-180px ;
    display: flex;
    justify-content: center;
    align-items: center;
    .left-heng3{
      .heng-blue3{
        margin-left:82px ;
        margin-bottom: 10px ;
        color: #5086c2;
        font-weight: 700;
        .num3{
          margin-right: 5px;
          // margin-left:10px ;
        }
        // .yuan3{
        //   position: absolute;
        //   // top: 1114px;
        //   top: 1134px;
        //   left: 32px;
        //   display: inline-block;
        //   width: 18px;
        //   height: 18px;
        //   border-radius: 50%;
        //   border: 1px solid #5086c2;
        // }
      }
        .moqing3{
          margin-left:110px ;
          color: #6f6b6b;
          font-size: 12px;
        }
    }
    .parks3{
      width: 130px;
      height: 100px;
      position: relative;
      top: 0;
      left: 97px;
    }
  }
  .hengpai4{
    margin-top:10px ;
    margin-left:-178px ;
    display: flex;
    justify-content: center;
    align-items: center;
    .left-heng4{
      .heng-blue4{
        margin-left:157px ;
        margin-bottom: 10px ;
        color: #5086c2;
        font-weight: 700;
        .num4{
          margin-right: 5px;
          // margin-left:10px ;
        }
        // .yuan4{
        //   position: absolute;
        //   // top: 1223px;
        //   top: 1243px;
        //   left: 33px;
        //   display: inline-block;
        //   width: 18px;
        //   height: 18px;
        //   border-radius: 50%;
        //   border: 1px solid #5086c2;
        // }
      }
        .moqing4{
          margin-left:184px ;
          color: #6f6b6b;
          font-size: 12px;
        }
    }
    .parks4{
      width: 130px;
      height: 100px;
      position: relative;
      top: 0;
      left: 19px;
    }
  }
  .guanjian{
    width: 90%;
    padding-top: 20px;
    margin: 0 auto;
  }
}
</style>
